export const getPlaceholder = (domain: string) => {
  const placeholders = [
    {
      domain: "default",
      value: "Contrôle d'identité, école, demande de rendez-vous….",
    },
    {
      domain: "administration",
      value: "Prime Rénov', rendez-vous, préfecture…",
    },
    {
      domain: "discrimination",
      value: `Refus candidature, handicap, contrôle d'identité…`,
    },
    {
      domain: "enfance",
      value: "Harcèlement, école, AESH…",
    },
    {
      domain: "deontologie",
      value: "Violences, dépôt plainte, contrôle d'identité…",
    },
    {
      domain: "alerte",
      value: "Déontologie, alimentation, financier…",
    },
    { domain: "autre", value: "Données personnelles, billet train…" },
  ];

  return placeholders.find(
    (placeholder) => placeholder.domain === domain && placeholder.value
  )?.value;
};
